export interface IUsuario {
  nombreCompleto: string;
  uid: string;
  nombres: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  correoElectronico: string;
  telefonoCelular: string;
  telefonoFijo: string;
  estado: boolean;
  ultimoInicioSesion: string;
  fechaCreacion: string;
  fechaActualizacion: string;
}
export class Usuario {
  nombreCompleto: string;
  uid: string;
  nombres: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  correoElectronico: string;
  telefonoCelular: string;
  telefonoFijo: string;
  estado: boolean;
  ultimoInicioSesion: Date;
  fechaCreacion: Date;
  fechaActualizacion: Date;

  constructor(data: IUsuario) {
    this.nombreCompleto = data.nombreCompleto;
    this.uid = data.uid;
    this.nombres = data.nombres;
    this.apellidoPaterno = data.apellidoPaterno;
    this.apellidoMaterno = data.apellidoMaterno;
    this.correoElectronico = data.correoElectronico;
    this.telefonoCelular = data.telefonoCelular;
    this.telefonoFijo = data.telefonoFijo;
    this.estado = data.estado;
    this.ultimoInicioSesion = new Date(data.ultimoInicioSesion);
    this.fechaCreacion = new Date(data.fechaCreacion);
    this.fechaActualizacion = new Date(data.fechaActualizacion);
  }

}
